import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import PrivacyModal from "../PrivacyModal/PrivacyModal";
import { FaPhone, FaEnvelope, FaLinkedin } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./Footer.css";

const Footer = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        form.current,
        EMAILJS_PUBLIC_KEY,
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message. Please try again.");
        },
      );
  };

  return (
    <>
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-column">
            <h4>Our Location</h4>
            <p>Softblitz Resources Inc</p>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d49630.93819473037!2d-77.4304935!3d38.9711833!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b638060f5da643%3A0x928022b51c6c357d!2sHerndon%2C%20VA%2020170!5e0!3m2!1sen!2sus!4v1755389524056!5m2!1sen!2sus"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map of our office location"
              ></iframe>
            </div>
          </div>

          <div className="footer-column">
            <h4>Contact Us</h4>
            <p>
              <FaPhone className="icon" /> +1 972 586 7070
            </p>
            <p>
              <FaEnvelope className="icon" />
              <a href="mailto:info@softblitzresources.com">
                info@softblitzresources.com
              </a>
            </p>
            <div className="social-links">
              <h4>Connect with Us</h4>
              <a
                href="https://www.linkedin.com/company/softblitz-resources-inc"
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-link"
                aria-label="LinkedIn"
              >
                <FaLinkedin className="social-icon" />
              </a>
              <Link to="/careers" className="careers-footer-link">
                Careers
              </Link>
            </div>
          </div>

          <div className="footer-column">
            <h4>Get in Touch</h4>
            <form ref={form} className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <hr className="footer-divider" />
          <span>© 2026 Softblitz Resources Inc. All rights reserved. | </span>
          <span className="privacy-link" onClick={() => setIsModalOpen(true)}>
            Privacy Policy
          </span>
        </div>
      </footer>
      <PrivacyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Footer;
